<template>
    <div style="display: inline-block;margin-bottom: 10px;vertical-align:middle">
      <!-- <el-form-item label="区域">
        <el-select v-model="provCityId.provCode" :defaultValue="provCityId.provCode !== '' ? provCityId.provCode : undefined" v-if="result.areaLevel<=1" placeholder="请选择省" style="width: 150px">
          <el-option
            v-for="item in listProv"
            :key="item.provCode"
            :label="item.provName"
            :value="item.provCode"
            @click.native="getshi(item)"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item >
        <el-select v-model="provCityId.cityCode" :defaultValue="provCityId.cityCode !== '' ? provCityId.cityCode : undefined" placeholder="请选择市" style="width: 160px" clearable>
          <el-option
            v-for="item in cityList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            @click.native="getxian(item)"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item >
        <el-select v-model="provCityId.countyCode" :defaultValue="provCityId.countyCode !== '' ? provCityId.countyCode : undefined" placeholder="请选择县" style="width: 160px" clearable>
          <el-option
            v-for="item in countyList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </div>
</template>

<script>
  import Api from '../../../Serves/net-api.js';
  import Http from '../../../Serves/net-http.js';
  import {mapState} from "vuex";
  export default {
    name: "provCity",
    props:['provCityId'],
    data(){
      return {
        listProv:[],
        listCity:[{cityName:"请选择省"}],
        listCounty:[{countyName:"请选择省和市"}],
        cityList: [],
        countyList: []
      }
    },
    computed:{
      ...mapState({
        result:state=>state.result
      })
    },
    mounted(){
      this.getCityList(this.$store.state.Code)
      // if(this.result.areaLevel==0){
      //   this.getlistProv()
      // }else if(this.result.areaLevel==1){
      //   this.listProv = [{provName:this.result.areaName,provCode:this.result.areaCode}]
      //   this.provCityId.provCode = this.result.areaCode
      //   this.getshi({provCode:this.result.areaCode})
      // }else if(this.$store.state.result.areaLevel==2){
      //   //市区
      //   this.listCity = [{cityName:this.result.areaName,cityCode:this.result.areaCode}]
      //   this.provCityId.cityCode = this.result.areaCode
      //   this.getxian({cityCode:this.result.areaCode})
      // }else if(this.$store.state.result.areaLevel==3){
      //   this.listCounty = [{countyName:this.result.areaName,countyCode:this.result.areaCode}]
      //   this.provCityId.countyCode = this.result.areaCode
      // }
    },
    methods:{
      getCityList (value) {
        Api.doPost(Http.test+'/area/getCityOfProvice',{ pId: value }, false,(res)=>{
          this.cityList = res.result
        })
      },
      getCountyList (value) {
        Api.doPost(Http.test+'/area/getCountyOfCityAndProvice', { cId: value }, false, (res) => {
          this.countyList = res.result
        })
      },
      // selectProv(item){
      //   // console.log(item,"item");
      // },
      // selectCity(item){
      // },
      //市
      getshi(item){
        this.provCityId.countyCode=''
        this.provCityId.cityCode=''
        if(item.provCode==""){
          this.listCity = [{cityName:"请选择省"}]
          this.listCounty = [{countyName:"请选择省和市"}]
          return false
        }
        let data={provCode :this.provCityId.provCode}
        let url=Http.test+'/common/listCity'
        Api.doPost(url,data,true,(res)=>{
          this.listCity=res.result.listCity
          this.listCity.unshift({
            cityName:"请选择",
            cityCode:''
          })
        },(doError)=>{})
        // this.status=true
      },
      //县
      getxian(item){
        this.getCountyList(item.value)
        // this.provCityId.countyCode=''
        // if(item.cityCode==""){
        //   this.listCounty = [{countyName:"请选择省和市"}]
        //   return false
        // }
        // let data={ cityCode:this.provCityId.cityCode}
        // let url=Http.test+'/common/listCounty'
        // Api.doPost(url,data,true,(res)=>{
        //   this.listCounty=res.result.listCounty
        //   this.listCounty.unshift({
        //     countyName:"请选择",
        //     countyCode:''
        //   })
        // },(doError)=>{})
        // this.statusx=true
      },
      //获取省
      getlistProv(){
        this.provCityId.cityCode=''
        this.provCityId.countyCode=''
        let url=Http.test+'/common/listProv'
        let parmse={}
        Api.doPost(url,parmse,true,(res)=>{
          this.listProv=res.result.listProv
          this.listProv.unshift({
            provName:"请选择省",
            provCode:''
          })
        },(doError)=>{
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Index/common/provCity.vue